module.exports = __webpack_public_path__ + "static/media/3.f8a6759e.jpg";